<form [formGroup]="group">
    <div class="div-boolean">
        <!-- TOGGLE -->
        <ng-container *ngIf="!showInList">
            <mat-label *ngIf="label" [class.readonly-field]="disabled">
                {{ label | translate }} <span>{{ isRequired ? '*' : '' }}</span>
            </mat-label>

            <mat-button-toggle-group [formControlName]="controlName">
                <mat-button-toggle [value]="true">{{ yesLabel | translate }}</mat-button-toggle>
                <mat-button-toggle [value]="false">{{ noLabel | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </ng-container>

        <!-- SELECT -->
        <mat-form-field *ngIf="showInList" class="w100">
            <mat-label>{{ label | translate }}</mat-label>
            <mat-select [formControlName]="controlName">
                <mat-option [value]=""></mat-option>
                <mat-option [value]="true">{{ yesLabel | translate }}</mat-option>
                <mat-option [value]="false">{{ noLabel | translate }}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-error *ngIf="isRequired && isErrorVisile" class="requiredError">
            <span>{{ 'ALDEN.VALIDATORS.ERRORS.REQUIRED' | translate }}</span>
        </mat-error>
    </div>
</form>